/**
 * Priority order for displaying entitlement fields.
 * Fields will be displayed in this order, with any unlisted fields appearing at the end in alphabetical order.
 */
export const ENTITLEMENT_FIELD_ORDER = [
  "projects",
  "tenants",
  "machines",
  "targets",
  "deploymentTargets",
  "users",
  "taskCap",
  "spaces",
  "nodes",
  "storageLimitGb",
  "retentionDays",
  "telemetryEnforced",
  "serviceNow",
  "jiraServiceManagement",
  "spaceLevelInsights",
  "auditLogFeeds",
  "priorityTask",
  "globalDeploymentFreeze",
  "processTemplates",
  "policies",
  "projectTemplates",
  "restrictedPermissions",
] as const;
